/** Must match functions-forms/src/wallet/autoRechargeConstants.ts */
export const AUTO_RECHARGE_CONSENT_TEXT =
  'I authorize gocta to charge the card on file $25 whenever my wallet balance drops below $5, up to 4 charges or $200 per calendar month. I can turn this off anytime on Billing.';

export const AUTO_RECHARGE_TOGGLE_LABEL =
  'Auto-recharge $25 when balance drops below $5 (max $200/month)';

export const AUTO_RECHARGE_BILLING_HREF = '/billing#auto-recharge';

export function formatAutoRechargeAuthorizedLine({ consentedAt, card } = {}) {
  let dateLabel = 'date on file';
  if (consentedAt) {
    const date =
      typeof consentedAt === 'string' || typeof consentedAt === 'number'
        ? new Date(consentedAt)
        : consentedAt.toDate
          ? consentedAt.toDate()
          : consentedAt.seconds != null || consentedAt._seconds != null
            ? new Date((consentedAt.seconds ?? consentedAt._seconds) * 1000)
            : new Date(consentedAt);
    if (!Number.isNaN(date.getTime())) {
      dateLabel = date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
  }
  const brand = card?.brand ? String(card.brand) : 'card';
  const last4 = card?.last4 ? String(card.last4) : '••••';
  return `Authorized ${dateLabel} · ${brand} •••• ${last4}`;
}
